// // inkybay-media.js
// // Built against Dawn's exact slider-component / product-media-gallery structure.

// (function () {
//   'use strict';

//   /* ─── State ──────────────────────────────────────────────────── */
//   var state         = 'inkybay';
//   var gallerySrc    = null;
//   var gallerySrcset = null;
//   var reverting     = false;
//   var inkybayBusy   = false;
//   var scrollTimer   = null;

//   /* ─── DOM helpers ────────────────────────────────────────────── */
//   // Dawn structure:
//   //  slider-component#GalleryViewer-{id}
//   //    ul#Slider-Gallery-{id}.product__media-list.slider.slider--mobile
//   //      li.product__media-item.slider__slide.is-active   ← active slide
//   //        modal-opener
//   //          div.product__media
//   //            img   ← THIS is the image we manage

//   function getSliderList() {
//     return document.querySelector('ul[id^="Slider-Gallery-"]');
//   }

//   function getActiveSlide() {
//     return (
//       document.querySelector('.product__media-item.slider__slide.is-active') ||
//       document.querySelector('.product__media-item.is-active') ||
//       document.querySelector('.slider__slide.is-active')
//     );
//   }

//   function getActiveImg() {
//     var slide = getActiveSlide();
//     if (slide) {
//       return (
//         slide.querySelector('.product__media img') ||
//         slide.querySelector('img')
//       );
//     }
//     // absolute fallback: first slide
//     return (
//       document.querySelector('ul[id^="Slider-Gallery-"] .slider__slide:first-child .product__media img') ||
//       document.querySelector('ul[id^="Slider-Gallery-"] .slider__slide:first-child img')
//     );
//   }

//   function captureGalleryImage() {
//     var img = getActiveImg();
//     if (img && img.src && img.src !== '') {
//       gallerySrc    = img.src;
//       gallerySrcset = img.srcset || '';
//     }
//   }

//   function revertToGallery() {
//     if (!gallerySrc) return;
//     var img = getActiveImg();
//     if (!img || img.src === gallerySrc) return;
//     reverting = true;
//     img.src   = gallerySrc;
//     if (gallerySrcset) img.srcset = gallerySrcset;
//   }

//   /* ─── Gallery action ─────────────────────────────────────────── */
//   function onGalleryAction() {
//     state = 'gallery';
//     // Capture at multiple points — Dawn's IntersectionObserver
//     // sets is-active slightly after scroll settles (~100–300ms)
//     setTimeout(captureGalleryImage, 150);
//     setTimeout(captureGalleryImage, 350);
//     setTimeout(captureGalleryImage, 700);
//   }

//   /* ─── Hook Inkybay ───────────────────────────────────────────── */
//   function hookInkybay() {
//     if (typeof window.selectProductColor === 'function') {
//       var orig = window.selectProductColor;
//       window.selectProductColor = function () {
//         state       = 'inkybay';
//         inkybayBusy = true;
//         clearTimeout(window._ibBusyTimer);
//         window._ibBusyTimer = setTimeout(function () {
//           inkybayBusy = false;
//         }, 350);
//         return orig.apply(this, arguments);
//       };
//     } else {
//       setTimeout(hookInkybay, 80);
//     }
//   }

//   /* ─── 1. Scroll listener on Dawn's slider UL (mobile core) ──── */
//   // Dawn mobile slider = ul.slider--mobile with CSS scroll-snap.
//   // Every swipe fires native 'scroll' on this element.
//   function attachScrollListener() {
//     var list = getSliderList();
//     if (!list) {
//       setTimeout(attachScrollListener, 200);
//       return;
//     }

//     list.addEventListener('scroll', function () {
//       if (inkybayBusy) return;
//       // Debounce: act when scrolling stops
//       clearTimeout(scrollTimer);
//       scrollTimer = setTimeout(function () {
//         onGalleryAction();
//       }, 120);
//     }, { passive: true });
//   }

//   /* ─── 2. Dawn's own slideChanged event ───────────────────────── */
//   // SliderComponent dispatches this after updating is-active.
//   // media-gallery.js re-dispatches it as well.
//   function attachSliderEvents() {
//     // Dawn fires slideChanged on the slider-component element
//     document.addEventListener('slideChanged', function () {
//       if (!inkybayBusy) onGalleryAction();
//     });

//     // Some Dawn forks / versions use this variant
//     document.addEventListener('on:slide:change', function () {
//       if (!inkybayBusy) onGalleryAction();
//     });
//   }

//   /* ─── 3. Click/tap — thumbnails & arrow buttons ──────────────── */
//   function attachClickListeners() {
//     function handle(target) {
//       // Thumbnail strip
//       if (target.closest('.thumbnail-list__item, .thumbnail')) {
//         onGalleryAction();
//         return;
//       }
//       // Prev/next arrows scoped to the product gallery slider
//       var btn = target.closest('.slider-button--prev, .slider-button--next');
//       if (btn) {
//         var inGallery =
//           btn.closest('[id^="GalleryViewer-"]') ||
//           btn.closest('.slider-mobile-gutter');
//         if (inGallery) onGalleryAction();
//       }
//     }

//     document.addEventListener('click',    function (e) { handle(e.target); }, true);
//     document.addEventListener('touchend', function (e) { handle(e.target); },
//       { passive: true, capture: true });
//   }

//   /* ─── MutationObserver ───────────────────────────────────────── */
//   function startObserver() {
//     var root = document.querySelector('ul[id^="Slider-Gallery-"]');
//     if (!root) {
//       setTimeout(startObserver, 200);
//       return;
//     }

//     var obs = new MutationObserver(function (mutations) {
//       for (var i = 0; i < mutations.length; i++) {
//         var m = mutations[i];

//         /* 1. Absorb our own revert write */
//         if (reverting) {
//           reverting = false;
//           return;
//         }

//         /* 2. Dawn sets is-active on the li after IntersectionObserver fires */
//         if (
//           m.type === 'attributes' &&
//           m.attributeName === 'class' &&
//           m.target.classList &&
//           m.target.classList.contains('slider__slide') &&
//           m.target.classList.contains('is-active') &&
//           !inkybayBusy
//         ) {
//           state = 'gallery';
//           setTimeout(captureGalleryImage, 150);
//           setTimeout(captureGalleryImage, 400);
//           continue;
//         }

//         /* 3. Image src/srcset changed */
//         if (
//           m.type === 'attributes' &&
//           (m.attributeName === 'src' || m.attributeName === 'srcset') &&
//           m.target.tagName === 'IMG'
//         ) {
//           if (state === 'inkybay') continue; // Inkybay in control — allow

//           // Revert only if the changed img is inside the active slide
//           var inActive =
//             m.target.closest('.product__media-item.is-active') ||
//             m.target.closest('.slider__slide.is-active');
//           if (inActive) revertToGallery();
//           continue;
//         }

//         /* 4. Inkybay injects a new <img> into the active slide */
//         if (m.type === 'childList' && state === 'gallery') {
//           var added = m.addedNodes;
//           for (var n = 0; n < added.length; n++) {
//             var node = added[n];
//             if (node.tagName === 'IMG') {
//               var inActiveSlide =
//                 node.closest && (
//                   node.closest('.product__media-item.is-active') ||
//                   node.closest('.slider__slide.is-active')
//                 );
//               if (inActiveSlide) {
//                 try { node.parentNode.removeChild(node); } catch (_) {}
//                 break;
//               }
//             }
//           }
//         }
//       }
//     });

//     obs.observe(root, {
//       attributes     : true,
//       attributeFilter: ['src', 'srcset', 'class'],
//       subtree        : true,
//       childList      : true,
//     });
//   }

//   /* ─── Init ───────────────────────────────────────────────────── */
//   function init() {
//     hookInkybay();
//     attachScrollListener();   
//     attachSliderEvents();     // Dawn's custom slideChanged event
//     attachClickListeners();   // thumbnails + arrow buttons
//     startObserver();
//     // Initial capture after Inkybay and Shopify both settle
//     setTimeout(captureGalleryImage, 800);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();

// // inkybay-media.js
// // Built against Dawn's exact slider-component / product-media-gallery structure.

// (function () {
//   'use strict';

//   /* ─── State ──────────────────────────────────────────────────── */
//   var state         = 'inkybay';
//   var gallerySrc    = null;
//   var gallerySrcset = null;
//   var reverting     = false;
//   var inkybayBusy   = false;
//   var scrollTimer   = null;

//   /* ─── DOM helpers ────────────────────────────────────────────── */
//   // Dawn structure:
//   //  slider-component#GalleryViewer-{id}
//   //    ul#Slider-Gallery-{id}.product__media-list.slider.slider--mobile
//   //      li.product__media-item.slider__slide.is-active   ← active slide
//   //        modal-opener
//   //          div.product__media
//   //            img   ← THIS is the image we manage

//   function getSliderList() {
//     return document.querySelector('ul[id^="Slider-Gallery-"]');
//   }

//   function getActiveSlide() {
//     return (
//       document.querySelector('.product__media-item.slider__slide.is-active') ||
//       document.querySelector('.product__media-item.is-active') ||
//       document.querySelector('.slider__slide.is-active')
//     );
//   }

//   function getActiveImg() {
//     var slide = getActiveSlide();
//     if (slide) {
//       return (
//         slide.querySelector('.product__media img') ||
//         slide.querySelector('img')
//       );
//     }
//     // absolute fallback: first slide
//     return (
//       document.querySelector('ul[id^="Slider-Gallery-"] .slider__slide:first-child .product__media img') ||
//       document.querySelector('ul[id^="Slider-Gallery-"] .slider__slide:first-child img')
//     );
//   }

//   function captureGalleryImage() {
//     var img = getActiveImg();
//     if (img && img.src && img.src !== '') {
//       gallerySrc    = img.src;
//       gallerySrcset = img.srcset || '';
//     }
//   }

//   function revertToGallery() {
//     if (!gallerySrc) return;
//     var img = getActiveImg();
//     if (!img || img.src === gallerySrc) return;
//     reverting = true;
//     img.src   = gallerySrc;
//     if (gallerySrcset) img.srcset = gallerySrcset;
//   }

//   /* ─── Gallery action ─────────────────────────────────────────── */
//   function onGalleryAction() {
//     state = 'gallery';
//     // Capture at multiple points — Dawn's IntersectionObserver
//     // sets is-active slightly after scroll settles (~100–300ms)
//     setTimeout(captureGalleryImage, 150);
//     setTimeout(captureGalleryImage, 350);
//     setTimeout(captureGalleryImage, 700);
//   }

//   /* ─── Hook Inkybay ───────────────────────────────────────────── */
//   function hookInkybay() {
//     if (typeof window.selectProductColor === 'function') {
//       var orig = window.selectProductColor;
//       window.selectProductColor = function () {
//         state       = 'inkybay';
//         inkybayBusy = true;
//         clearTimeout(window._ibBusyTimer);
//         window._ibBusyTimer = setTimeout(function () {
//           inkybayBusy = false;
//         }, 350);
//         return orig.apply(this, arguments);
//       };
//     } else {
//       setTimeout(hookInkybay, 80);
//     }
//   }

//   /* ─── 1. Scroll listener on Dawn's slider UL (mobile core) ──── */
//   // Dawn mobile slider = ul.slider--mobile with CSS scroll-snap.
//   // Every swipe fires native 'scroll' on this element.
//   function attachScrollListener() {
//     var list = getSliderList();
//     if (!list) {
//       setTimeout(attachScrollListener, 200);
//       return;
//     }

//     list.addEventListener('scroll', function () {
//       if (inkybayBusy) return;
//       // Debounce: act when scrolling stops
//       clearTimeout(scrollTimer);
//       scrollTimer = setTimeout(function () {
//         onGalleryAction();
//       }, 120);
//     }, { passive: true });
//   }

//   /* ─── 2. Dawn's own slideChanged event ───────────────────────── */
//   // SliderComponent dispatches this after updating is-active.
//   // media-gallery.js re-dispatches it as well.
//   function attachSliderEvents() {
//     // Dawn fires slideChanged on the slider-component element
//     document.addEventListener('slideChanged', function () {
//       if (!inkybayBusy) onGalleryAction();
//     });

//     // Some Dawn forks / versions use this variant
//     document.addEventListener('on:slide:change', function () {
//       if (!inkybayBusy) onGalleryAction();
//     });
//   }

//   /* ─── 3. Click/tap — thumbnails & arrow buttons ──────────────── */
//   function attachClickListeners() {
//     function handle(target) {
//       // Thumbnail strip
//       if (target.closest('.thumbnail-list__item, .thumbnail')) {
//         onGalleryAction();
//         return;
//       }
//       // Prev/next arrows scoped to the product gallery slider
//       var btn = target.closest('.slider-button--prev, .slider-button--next');
//       if (btn) {
//         var inGallery =
//           btn.closest('[id^="GalleryViewer-"]') ||
//           btn.closest('.slider-mobile-gutter');
//         if (inGallery) onGalleryAction();
//       }
//     }

//     document.addEventListener('click',    function (e) { handle(e.target); }, true);
//     document.addEventListener('touchend', function (e) { handle(e.target); },
//       { passive: true, capture: true });
//   }

//   /* ─── MutationObserver ───────────────────────────────────────── */
//   function startObserver() {
//     var root = document.querySelector('ul[id^="Slider-Gallery-"]');
//     if (!root) {
//       setTimeout(startObserver, 200);
//       return;
//     }

//     var obs = new MutationObserver(function (mutations) {
//       for (var i = 0; i < mutations.length; i++) {
//         var m = mutations[i];

//         /* 1. Absorb our own revert write */
//         if (reverting) {
//           reverting = false;
//           return;
//         }

//         /* 2. Dawn sets is-active on the li after IntersectionObserver fires */
//         if (
//           m.type === 'attributes' &&
//           m.attributeName === 'class' &&
//           m.target.classList &&
//           m.target.classList.contains('slider__slide') &&
//           m.target.classList.contains('is-active') &&
//           !inkybayBusy
//         ) {
//           state = 'gallery';
//           setTimeout(captureGalleryImage, 150);
//           setTimeout(captureGalleryImage, 400);
//           continue;
//         }

//         /* 3. Image src/srcset changed */
//         if (
//           m.type === 'attributes' &&
//           (m.attributeName === 'src' || m.attributeName === 'srcset') &&
//           m.target.tagName === 'IMG'
//         ) {
//           if (state === 'inkybay') continue; // Inkybay in control — allow

//           // Revert only if the changed img is inside the active slide
//           var inActive =
//             m.target.closest('.product__media-item.is-active') ||
//             m.target.closest('.slider__slide.is-active');
//           if (inActive) revertToGallery();
//           continue;
//         }

//         /* 4. Inkybay injects a new <img> into the active slide */
//         if (m.type === 'childList' && state === 'gallery') {
//           var added = m.addedNodes;
//           for (var n = 0; n < added.length; n++) {
//             var node = added[n];
//             if (node.tagName === 'IMG') {
//               var inActiveSlide =
//                 node.closest && (
//                   node.closest('.product__media-item.is-active') ||
//                   node.closest('.slider__slide.is-active')
//                 );
//               if (inActiveSlide) {
//                 try { node.parentNode.removeChild(node); } catch (_) {}
//                 break;
//               }
//             }
//           }
//         }
//       }
//     });

//     obs.observe(root, {
//       attributes     : true,
//       attributeFilter: ['src', 'srcset', 'class'],
//       subtree        : true,
//       childList      : true,
//     });
//   }

//   /* ─── Init ───────────────────────────────────────────────────── */
//   function init() {
//     hookInkybay();
//     attachScrollListener();   // PRIMARY mobile fix — hooks Dawn's scroll-snap UL
//     attachSliderEvents();     // Dawn's custom slideChanged event
//     attachClickListeners();   // thumbnails + arrow buttons
//     startObserver();
//     // Initial capture after Inkybay and Shopify both settle
//     setTimeout(captureGalleryImage, 800);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();

// inkybay-media.js  v4
// Fix over v1: per-slide originals map instead of single gallerySrc variable.
// Requires inline capture script in product-media-gallery.liquid.

(function () {
  'use strict';

  /* ─── State ──────────────────────────────────────────────────── */
  var state       = 'inkybay';
  var inkybayBusy = false;
  var scrollTimer = null;
  var obs         = null;
  var obsRoot     = null;

  var OBS_CONFIG = {
    attributes     : true,
    attributeFilter: ['src', 'srcset', 'class'],
    subtree        : true,
    childList      : true
  };

  /* ─── Per-slide originals (populated by inline script BEFORE Inkybay) ── */
  function getOriginal(mediaId) {
    return (window.__inkybayOriginals || {})[mediaId] || null;
  }

  /* ─── DOM helpers ────────────────────────────────────────────── */
  function getSliderUL() {
    return document.querySelector('ul[id^="Slider-Gallery-"]');
  }

  /**
   * Find which slide is currently visible.
   * Uses .is-active first (set by Dawn on click nav).
   * Falls back to scroll-position math for mobile swipe,
   * where Dawn's IntersectionObserver may NOT update .is-active.
   */
  function getActiveSlide() {
    var byClass = document.querySelector('ul[id^="Slider-Gallery-"] li.is-active');
    if (byClass) return byClass;

    var ul = getSliderUL();
    if (ul) {
      var slides = ul.querySelectorAll('li.slider__slide');
      var center = ul.scrollLeft + ul.clientWidth / 2;
      var best   = null;

      for (var i = 0; i < slides.length; i++) {
        var s   = slides[i];
        var sL  = s.offsetLeft;
        var sR  = sL + s.offsetWidth;
        if (sL <= center && sR > center) return s;
        if (sL <= center) best = s;
      }

      if (best) return best;
      if (slides.length) return slides[0];
    }

    return null;
  }

  function getActiveImg() {
    var slide = getActiveSlide();
    return slide
      ? (slide.querySelector('.product__media img') || slide.querySelector('img'))
      : null;
  }

  function getActiveMediaId() {
    var slide = getActiveSlide();
    return slide ? (slide.getAttribute('data-media-id') || null) : null;
  }

  /* ─── Revert the active slide to its original Shopify image ─── */
  function revertToGallery() {
    var mediaId = getActiveMediaId();
    if (!mediaId) return;

    var orig = getOriginal(mediaId);
    if (!orig || !orig.src) return;

    var img = getActiveImg();
    if (!img) return;

    if ((img.getAttribute('src') || '') === orig.src) return; // already correct

    // Disconnect before writing so we don't trigger ourselves
    obsDisconnect();
    img.setAttribute('src', orig.src);
    if (orig.srcset) img.setAttribute('srcset', orig.srcset);
    obsConnect();
  }

  /* ─── Observer helpers ───────────────────────────────────────── */
  function obsConnect()    { if (obs && obsRoot) obs.observe(obsRoot, OBS_CONFIG); }
  function obsDisconnect() { if (obs) obs.disconnect(); }

  /* ─── Gallery action ─────────────────────────────────────────── */
  function onGalleryAction() {
    state = 'gallery';
    // Multiple timed attempts: Dawn's IntersectionObserver + scroll animation
    // can delay the is-active update by up to ~400ms on mobile
    [80, 300, 600].forEach(function (ms) {
      setTimeout(function () { if (state === 'gallery') revertToGallery(); }, ms);
    });
  }

  /* ─── Hook Inkybay's selectProductColor ─────────────────────── */
  function hookInkybay() {
    if (typeof window.selectProductColor === 'function') {
      var _orig = window.selectProductColor;
      window.selectProductColor = function () {
        state       = 'inkybay';
        inkybayBusy = true;
        clearTimeout(window._ibBusyTimer);
        window._ibBusyTimer = setTimeout(function () { inkybayBusy = false; }, 700);
        return _orig.apply(this, arguments);
      };
    } else {
      setTimeout(hookInkybay, 80);
    }
  }

  /* ─── Scroll listener — mobile swipe ────────────────────────── */
  function attachScrollListener() {
    var ul = getSliderUL();
    if (!ul) { setTimeout(attachScrollListener, 200); return; }

    ul.addEventListener('scroll', function () {
      if (inkybayBusy) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(onGalleryAction, 150);
    }, { passive: true });

    // scrollend fires once when scroll fully settles (Chrome 114+, Firefox 109+)
    ul.addEventListener('scrollend', function () {
      if (!inkybayBusy) onGalleryAction();
    }, { passive: true });
  }

  /* ─── Dawn slider events ─────────────────────────────────────── */
  function attachSliderEvents() {
    ['slideChanged', 'on:slide:change'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        if (!inkybayBusy) onGalleryAction();
      });
    });
  }

  /* ─── Click / touch on thumbnails and arrow buttons ─────────── */
  function attachClickListeners() {
    function handle(target) {
      if (target.closest('.thumbnail-list__item, .thumbnail')) {
        onGalleryAction();
        return;
      }
      var btn = target.closest('.slider-button--prev, .slider-button--next');
      if (btn && btn.closest('[id^="GalleryViewer-"], .slider-mobile-gutter')) {
        onGalleryAction();
      }
    }
    document.addEventListener('click',    function (e) { handle(e.target); }, true);
    document.addEventListener('touchend', function (e) { handle(e.target); },
      { passive: true, capture: true });
  }

  /* ─── MutationObserver ───────────────────────────────────────── */
  function startObserver() {
    obsRoot = getSliderUL();
    if (!obsRoot) { setTimeout(startObserver, 200); return; }

    obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        /* A. Slide gained is-active → gallery navigation (not Inkybay) */
        if (
          m.type === 'attributes' &&
          m.attributeName === 'class' &&
          m.target.classList &&
          m.target.classList.contains('slider__slide') &&
          m.target.classList.contains('is-active') &&
          !inkybayBusy
        ) {
          state = 'gallery';
          [100, 350].forEach(function (ms) {
            setTimeout(function () { if (state === 'gallery') revertToGallery(); }, ms);
          });
          continue;
        }

        /* B. img src/srcset changed while gallery is in control */
        if (
          m.type === 'attributes' &&
          (m.attributeName === 'src' || m.attributeName === 'srcset') &&
          m.target.tagName === 'IMG' &&
          state === 'gallery' &&
          m.target.closest('.product__media-item, .slider__slide')
        ) {
          revertToGallery();
          continue;
        }

        /* C. Inkybay injected a new <img> while gallery is in control */
        if (m.type === 'childList' && state === 'gallery') {
          for (var n = 0; n < m.addedNodes.length; n++) {
            var node = m.addedNodes[n];
            if (node.tagName === 'IMG' && node.closest &&
                node.closest('.product__media-item, .slider__slide')) {
              try { node.parentNode.removeChild(node); } catch (_) {}
            }
          }
        }
      }
    });

    obsConnect();
  }

  /* ─── Init ───────────────────────────────────────────────────── */
  function init() {
    hookInkybay();
    attachScrollListener();
    attachSliderEvents();
    attachClickListeners();
    startObserver();
    // NOTE: no captureGalleryImage() here — originals come from
    // window.__inkybayOriginals (inline script), not live DOM reads
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();